/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Analytics_TitleInputs */

const en_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics Dashboard`)
};

const de_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysen-Dashboard`)
};

const fr_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord d'analyses`)
};

const es_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de análisis`)
};

const it_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard analitica`)
};

const nl_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytisch dashboard`)
};

const pl_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel analityczny`)
};

const fi_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikkapaneeli`)
};

const da_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysedashboard`)
};

const sv_landing_feature_analytics_title = /** @type {(inputs: Landing_Feature_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysinstrumentpanel`)
};

/**
* | output |
* | --- |
* | "Analytics Dashboard" |
*
* @param {Landing_Feature_Analytics_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_analytics_title = /** @type {((inputs?: Landing_Feature_Analytics_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Analytics_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_analytics_title(inputs)
	if (locale === "fr") return fr_landing_feature_analytics_title(inputs)
	if (locale === "es") return es_landing_feature_analytics_title(inputs)
	if (locale === "it") return it_landing_feature_analytics_title(inputs)
	if (locale === "nl") return nl_landing_feature_analytics_title(inputs)
	if (locale === "pl") return pl_landing_feature_analytics_title(inputs)
	if (locale === "fi") return fi_landing_feature_analytics_title(inputs)
	if (locale === "da") return da_landing_feature_analytics_title(inputs)
	if (locale === "sv") return sv_landing_feature_analytics_title(inputs)
	return en_landing_feature_analytics_title(inputs)
});